import {upgradesService} from "../_services";

export default {
  namespaced: true,
  state: {
    versions: [],
    deviceUpgrades: [],
    deviceUpgradeRules: [],
    circuitUpgradeRules: []
  },
  actions: {
    findAllVersions({commit}) {
      return upgradesService
        .findAllPackages()
        .then(response => {
          let versions = response.data['packages'].map(function(item) {return item.version});
          commit("findAllVersionsSuccess", versions);
        })
        .catch(error => {
          commit("findAllVersionsFailure", error);
          this.dispatch("alert/error","Error retrieving available package versions.");
        });
    },
    updatePackagesFromArtifactory() {
      upgradesService
        .updatePackagesFromArtifactory()
        .catch(() => {
          this.dispatch("alert/error","Error retrieving packages from artifactory.");
        });
    },
    requestUpgradeCircuit({ commit }, { selectedCircuit, versionSeleced }) {
      return upgradesService.requestUpgradeCircuit(selectedCircuit, versionSeleced);
    },
    requestUpgradeDevices({ commit }, { device, versionSeleced }) {
      return upgradesService.requestUpgradeDevices(device, versionSeleced);
    },
    editUpgradeRuleForDevice({ commit }, device) {
      return upgradesService.editUpgradeRuleForDevice(device);
    },
    findAllDeviceUpgrades({commit}) {
      upgradesService.findAllDeviceUpgrades()
      .then(response => {
        commit("findAllDeviceUpgradesSuccess", response.data['devices']);
      })
    },
    findAllCircuitUpgradeRules({commit}) {
      upgradesService.findAllCircuitUpgradeRules()
      .then(response => {
        const rules = response.data.filter(rule => rule.upgrade_rule !== null)
        commit("findAllCircuitUpgradeRulesSuccess", rules);
      })
    },
    findAllDeviceUpgradeRules({commit}) {
      upgradesService.findAllDeviceUpgradeRules()
      .then(response => {
        const rules = response.data.filter(rule => rule.upgrade_rule !== null)
        commit("findAllDeviceUpgradeRulesSuccess", rules);
      })
    },
    deleteCircuitUpgradeRuleLocally({ commit }, circuit_uuid) {
      commit("removeCircuitUpgradeRule", circuit_uuid);
    },
    editCircuitUpgradeRuleLocally({ commit }, updatedRule) {
      commit("updateCircuitUpgradeRule", updatedRule);
    }
  },
  getters: {
    versions: state => state.versions,
    deviceUpgrades: state => state.deviceUpgrades,
    circuitUpgradeRules: state => state.circuitUpgradeRules,
    deviceUpgradeRules: state => state.deviceUpgradeRules
  },
  mutations: {
    findAllVersionsSuccess(state, versions) {
      state.versions = versions;
    },
    findAllVersionsFailure(state) {
      state.versions = [];
    },
    findAllDeviceUpgradesSuccess(state, deviceUpgrades) {
      state.deviceUpgrades = deviceUpgrades;
    },
    findAllDeviceUpgradesFailure(state) {
      state.deviceUpgrades = [];
    },
    findAllDeviceUpgradeRulesSuccess(state, deviceUpgradeRules) {
      state.deviceUpgradeRules = deviceUpgradeRules;
    },
    findAllCircuitUpgradeRulesSuccess(state, circuitUpgradeRules) {
      state.circuitUpgradeRules = circuitUpgradeRules;
    },
    removeCircuitUpgradeRule(state, circuit_uuid) {
      state.circuitUpgradeRules = state.circuitUpgradeRules.filter(
        rule => rule.circuit_uuid !== circuit_uuid
      );
    },
    updateCircuitUpgradeRule(state, updatedRule) {
      const index = state.circuitUpgradeRules.findIndex(
        rule => rule.circuit_uuid === updatedRule.circuit_uuid
      );
      if (index !== -1) {
        state.circuitUpgradeRules.splice(index, 1, { ...state.circuitUpgradeRules[index], ...updatedRule });
      }
    }
  }
};
